class RecommendFeturedProducts extends HTMLElement {
  constructor() {
    super();
    this.prevBtn = this.querySelector(".prevBtn");
    this.nextBtn = this.querySelector(".nextBtn");
    // need to know width of scroll content area
    this.content = this.querySelector(".grid-overflow-wrapper");
    this.scrollControl = this.querySelector("footer.scroll-control");
    this.thumb = this.scrollControl.querySelector(".thumb");
    /** behaviors */
    this.updateThumbPosition();
    this.content.addEventListener("scroll", () => this.updateThumbPosition());
    this.prevBtn.addEventListener("click", (e) => this.scrollBy(e));
    this.nextBtn.addEventListener("click", (e) => this.scrollBy(e));
  }

  updateThumbPosition() {
    const contentWidth = this.content.scrollWidth;
    const contentScrollLeft = this.content.scrollLeft;
    const containerWidth = this.content.clientWidth;
    if (this.isScrollable(contentWidth, containerWidth)) return;

    const scrollbarWidth =
      this.scrollControl.querySelector(".scrollbar").clientWidth;

    const scrollRatio = containerWidth / contentWidth;
    const thumbWidth = Math.floor(Math.max(scrollRatio * scrollbarWidth, 20));
    const maxScrollRight = contentWidth - containerWidth;
    const maxThumbRight = scrollbarWidth - thumbWidth;
    const thumbPosition = (contentScrollLeft / maxScrollRight) * maxThumbRight;
    this.disabledButton(thumbPosition, maxThumbRight);
    this.thumb.style.width = thumbWidth + "px";
    this.thumb.style.transform = `translateX(${thumbPosition}px)`;
  }

  isScrollable(content, container) {
    const remainWidth = content - container;
    if (remainWidth < 20 && !this.isMobileDevice()) {
      this.scrollControl.classList.add("scroll-control__hiden");
      return true;
    } else {
      this.scrollControl.classList.remove("scroll-control__hiden");
      return false;
    }
  }

  scrollBy(event) {
    const scrollAmount = this.content.scrollWidth * 0.2;
    if (event.currentTarget.className === "prevBtn") {
      this.content.scrollLeft -= scrollAmount;
    } else {
      this.content.scrollLeft += scrollAmount;
    }
  }

  /***** Check if it is mobile */
  isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  disabledButton(thumbPosition, maxThumbRight) {
    if (thumbPosition === 0) {
      this.prevBtn.disabled = true;
    } else {
      this.prevBtn.disabled = false;
    }

    if (thumbPosition == maxThumbRight) {
      this.nextBtn.disabled = true;
    } else {
      this.nextBtn.disabled = false;
    }
  }
}
window.addEventListener("DOMContentLoaded", () => {
  customElements.define("recommend-fetured-products", RecommendFeturedProducts);
});
